"use client"

import * as React from "react"

import { useQuestionDimensions } from "@/hooks/use-category-dimensions"
import { useExamCategories } from "@/hooks/use-exam-categories"
import {
  buildCategoryTree,
  questionLevelCategories,
  type ExamCategory,
  type ExamCategoryTreeNode,
} from "@/lib/exam-categories"

/**
 * The categories an author picks from, everywhere a question is tagged: the
 * editor, the question sheet, Leo's pickers, the blueprint. One list, so a
 * change to which standards a question carries lands in all of them at once
 * and no picker offers a program-level standard the editor does not.
 */
export function useQuestionCategories(): {
  /** Question-level only. */
  categories: ExamCategory[]
  tree: ExamCategoryTreeNode[]
  /** Every category, for resolving a name or path that is not question-level. */
  all: ExamCategory[]
} {
  const { categories: all } = useExamCategories()
  const dimensions = useQuestionDimensions()
  return React.useMemo(() => {
    const categories = questionLevelCategories(all, dimensions)
    return { categories, tree: buildCategoryTree(categories), all }
  }, [all, dimensions])
}
